export default __webpack_public_path__ + "static/media/ic_logo.45f26ea9.svg";